import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { uniqBy } from 'lodash';
import RelatedArticles from '@package/components/View/UOView/RelatedArticlesServicesUO';

/**
 * UOServices component class.
 * @function UOServices
 * -
 * CUSTOMIZATION:
 * - showimage={false} to RelatedArticles
 * - servizi_offerti defaultMessage
 * - RelatedItems path changed for further customizations - see RelatedArticlesServicesUO for more
 * - prestazioni merged with servizi_offerti, without duplicates and sorted by title
 */

/**
 * important note:
 * AUSL-PC have a customization to defaultMessage servizi_offerti. If this component is removed,
 * this message need to be re-done inside overrideTranslations
 * src/components/View/UOView/OverrideTranslations.jsx
 * */

const messages = defineMessages({
  servizi_offerti: {
    id: 'servizi_offerti',
    defaultMessage: 'Prestazioni',
  },
});

const UOServices = ({ content }) => {
  const intl = useIntl();

  // servizi_offerti: services with this UO as "ufficio_responsabile"
  // prestazioni: services with this UO in "dove_rivolgersi"
  // the same service can be in both lists
  const services = uniqBy(
    [...(content?.servizi_offerti ?? []), ...(content?.prestazioni ?? [])],
    '@id',
  ).sort((a, b) => a.title.localeCompare(b.title, 'it', { numeric: true }));

  return services.length > 0 ? (
    <RelatedArticles
      id="related-services"
      items={services}
      title={intl.formatMessage(messages.servizi_offerti)}
      showimage={false}
    />
  ) : (
    <></>
  );
};

export default UOServices;
